import { Socket, Presence, Channel } from 'phoenix';
import { Ipad } from '../core/_models';
import { useState, useEffect } from 'react';
import { getUserAuth } from '../core/_axios';
import { BASE_WSS_URL } from '../core/_requests';

export default function useIpadDeviceChannel({ iPad }: { iPad: Ipad }) {

    const [ipadIsConnected, setIpadIsConnected] = useState(false);

    const [channel, setChannel] = useState<Channel | null>(null);

    useEffect(() => {
        console.log('connecting to socket')
        const socket = new Socket(`${BASE_WSS_URL}/socket/ipad`, {
            params: {
                web_token: getUserAuth()?.api_token
            }
        });
        const updatedChannel = socket.channel(`ipad:device:${iPad.unique_identifier}`, {
            from_web: true // maybe a local ID one day?
        });
        setChannel(updatedChannel)
        const presence = new Presence(updatedChannel)
        socket.connect();
        presence.onSync(() => {
            presence.list((id, { metas: metaItems }) => {
                const connectedIpads = metaItems.filter((x: any) => !!x.ipad_local_identifier)
                setIpadIsConnected(connectedIpads.length > 0)
            })
        })
        updatedChannel.join()
            .receive("ok", resp => {

            })
            .receive("error", resp => {

            })
        return () => {
            updatedChannel.leave()
            socket.disconnect()
        }
    }, [iPad.unique_identifier]);

    return {
        ipadIsConnected,
        channel
    }
}